import { useEffect } from "react";
import newsConfig from "../../config";

export function useGetRowDetailHeight<T>(
	newsProp: T[],
	setRowDetailHeight: (v: number) => void,
) {
	useEffect(() => {
		const detailsHeigth = newsProp?.length
			? newsConfig.DETAILS_HEIGHT.EXPENDED
			: newsConfig.DETAILS_HEIGHT.COLLAPSED;

		setRowDetailHeight(detailsHeigth);
	}, [newsProp, setRowDetailHeight]);
}
